<template>
	<div>
		<div class="title-container">
			<div class="title">Update User</div>
			<div class="buttons">
				<router-link to="/admin/accounts/users" exact class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
			</div>
		</div>

		<form-errors v-if="hasErrors" :errors="errors"></form-errors>

		<form action="post" @submit.prevent="onSubmit">

			<field-errors v-if="submitAttempted" :form="$v.form" field="name"></field-errors>
			<div class="input-container">
				<div class="input-title">Name</div>
				<div class="input-box"><input type="text" v-model="form.name"></div>
			</div>
			<field-errors v-if="submitAttempted" :form="$v.form" field="email"></field-errors>
			<div class="input-container">
				<div class="input-title">Email Address</div>
				<div class="input-box"><input type="text" v-model="form.email"></div>
			</div>
			<field-errors v-if="submitAttempted" :form="$v.form" field="accounts"></field-errors>
			<div class="input-container">
				<div class="input-title">Select Account(s)</div>
				<div class="input-box">
					<selectize v-model="form.accounts" :settings="accountSettings" placeholder="Select Account(s)" multiple></selectize>
				</div>
			</div>

			<submit-button text="Update Now" icon="fa-save" :has-errors="hasErrors" :loading="formSaving"></submit-button>
		</form>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
import FormMixin from '@/mixins/FormMixin';

export default {

	name: 'AdminAccountUsersDetailsPage',

	mixins: [FormMixin],

	async asyncData({ app, route }) {
		const { data } = await app.$api.get(`/super/accounts/users/${ route.params.id }/edit`);

		let user = data.data;
		user.accounts = user.all_accounts.map(account => account.id);

		return {
			form: data.data,
		};
	},

	data() {
		return {
			form: {},
		};
	},

	computed: {

		...mapGetters([ 'accounts', ]),

		accountSettings() {
			return {
				options: this.accounts.map(account => ({
					value: account.id,
					text: account.name
				})),
				create: false,
			};
		},

	},

	validations: {
		form: {
			name: { required },
			email: { required, email },
		},
	},

	methods: {

		async onSubmit() {
			this.submit(async () => {
				await this.$api.put(`/super/accounts/users/${ this.form.id }`, this.form);

				this.$store.dispatch('addToast', 'User Updated');
				this.$router.replace('/admin/accounts/users');
			}, () => {
				this.$store.dispatch('errorToast', 'There was a problem updating this user');
			});
		}
	}

};

</script>
